import * as React from 'react';

import './style.scss';

interface Props {
    children: React.ReactNode;
    visible?: boolean;
}

export const InputError: React.FunctionComponent<Props> = ({children, visible=false}) => {
    if(!visible) return null;

    return (
        <span className="input-error">
            {children}
        </span>
    )
};
